"use client";

import { Icon } from "@iconify/react";
import { Divider } from "@nextui-org/divider";

import { LineItemProps } from "@/interfaces";

export const LineItem: React.FC<LineItemProps> = ({
  icon,
  leftText,
  rightText,
  isRightBold = false,
  isLeftIconBig = false,
}) => {
  return (
    <div className="flex mx-1 pr-1 my-4 flex-row flex-wrap justify-between items-center">
      <div className="flex flex-row justify-center items-center">
        <Icon
          className={
            isLeftIconBig ? "text-default p-1 ml-2 lg:mr-3 mr-1" : "text-default p-0"
          }
          fontSize={isLeftIconBig ? 20 : 40}
          icon={icon}
        />
        <span>{leftText}</span>
      </div>
      <div className="flex flex-row justify-center items-center">
        <span className="xl:text-lg lg:text-md md:text-sm text-xs">
        {isRightBold && <strong>{rightText}</strong>}
        {!isRightBold && rightText}
        </span>
      </div>
      <Divider />
    </div>
  );
};
